import { Link } from '@tanstack/react-router'
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline'
import { Button } from '@duck/ui'
import { useTar } from '@/modules'
import { Logo } from '../Misc/Logo'

export function NotFoundPage() {
  const { t } = useTar()

  return (
    <div className="flex flex-1 w-full justify-center items-center min-h-[60vh]">
      <div className="flex-1 max-w-2xl px-6">
        <div className="text-center space-y-8">
          {/* 404 badge */}
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-2xl bg-muted/50 border border-border">
            <span className="text-4xl font-bold text-muted-foreground tabular-nums">
              404
            </span>
          </div>

          {/* Heading */}
          <div className="space-y-3">
            <h1 className="text-3xl md:text-4xl font-bold text-foreground">
              {t('common.pageNotFoundTitle')}
            </h1>
            <p className="text-lg text-muted-foreground max-w-md mx-auto">
              {t('common.pageNotFoundDescription')}
            </p>
          </div>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button asChild size="lg" className="gap-2 bg-accent hover:bg-accent/90 text-white">
              <Link to="/">
                <HomeIcon className="w-5 h-5" />
                {t('common.goHome')}
              </Link>
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="gap-2"
              onClick={() => window.history.back()}
            >
              <ArrowLeftIcon className="w-5 h-5" />
              {t('common.back')}
            </Button>
          </div>

          {/* Brand */}
          <div className="pt-8">
            <Link to="/" className="inline-block transition-opacity hover:opacity-80">
              <Logo className="text-xl" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
